import { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import ByTheNumbers from '@/components/about/outdoorsy-group/ByTheNumbers';
import Hero from '@/components/about/outdoorsy-group/Hero';
import LatestNewsSpotlight from '@/components/about/outdoorsy-group/LatestNewsSpotlight';
import LineOfBusiness from '@/components/about/outdoorsy-group/LineOfBusiness';
import type { TPageWithHeader } from '@/components/ui/GlobalHeader/GlobalHeaderV2/headerConfig';

const Timeline = dynamic(() => import('@/components/about/outdoorsy-group/Timeline'));
const InTheNews = dynamic(() => import('@/components/about/outdoorsy-group/InTheNews'));
const PartnerWithUs = dynamic(() => import('@/components/about/outdoorsy-group/PartnerWithUs'));

const OutdoorsyGroup: NextPage & TPageWithHeader = () => {
  return (
    <>
      <Hero />
      <LatestNewsSpotlight />
      <LineOfBusiness />
      <ByTheNumbers />
      <Timeline />
      <InTheNews />
      <PartnerWithUs />
    </>
  );
};

OutdoorsyGroup.header = { preset: 'white' };

export default OutdoorsyGroup;
